<template>
  <div class="main">
    <tab title="首页" rightText='' :fixed="false"></tab>
    <div class="top_kanban">
      <div class="bg_img">
        <img src="../../static/img/oil_c.png" alt="" />
      </div>
   <div style="display: flex;">
     <div class="top_ye">
       <div class="balance">{{ totalBalance }}</div>
       <div style="margin-bottom: 10px;">子账户总余额</div>
<!--       <div style="display: flex; justify-content: center; ">-->
<!--         <div @click="showModal = true" style="background-color: #3096E1; width: 50%; height: 30px; color: white; border-radius: 6px; line-height: 30px">充值</div>-->
<!--       </div>-->
     </div>
     <div class="top_ye">
       <div class="balance">{{ balance }}</div>
       可分配余额
     </div>
   </div>
    </div>
    <div class="choose_fuc">
      <div class="choose_fuc_title">流水查询</div>
      <div class="chooseBox">
        <div class="choose" @click="toTopup">
          <div class="choose_top">
            <img src="../../static/img/top.png" alt="" />
          </div>
          <div class="choose_text">充值流水</div>
        </div>
        <div class="choose" @click="distributionRecord">
          <div class="choose_top">
            <img src="../../static/img/distribution.png" alt="" />
          </div>
          <div class="choose_text">分配流水</div>
        </div>
        <div class="choose" @click="ComeOnRecord">
          <div class="choose_top">
            <img src="../../static/img/comon.png" alt="" />
          </div>
          <div class="choose_text">加油流水</div>
        </div>
      </div>
      <!-- <van-cell-group>
            <van-cell title="加油卡列表" value=">" to="/jiayou_card"/>
            <van-cell title="车卡列表" value=">" to="/cardList"/>
            <van-cell title="司机列表" value=">" to="/driver_list"/>
            <van-cell title="分配记录" value=">" to="/distribution_record"/>
            <van-cell title="加油记录" value=">" to="/ComeOn_record"/>
            <van-cell title="充值流水" value=">" to="/top_up" />
            <van-cell title="修改密码" value=">" to="/upd_password"/>
        </van-cell-group> -->
    </div>
    <div class="choose_fuc">
      <div class="choose_fuc_title">资金管理</div>
      <div class="chooseBox">
        <div class="choose" @click="jiayouCard">
          <div class="choose_top">
            <img src="../../static/img/comnCard.png" alt="" />
          </div>
          <div class="choose_text">加油卡</div>
        </div>
        <div class="choose" @click="cardList">
          <div class="choose_top">
            <img src="../../static/img/carCard.png" alt="" />
          </div>
          <div class="choose_text">车卡</div>
        </div>
        <div class="choose" @click="driverList">
          <div class="choose_top">
            <img src="../../static/img/driver.png" alt="" />
          </div>
          <div class="choose_text">司机</div>
        </div>
      </div>
      <!-- <van-cell-group>
            <van-cell title="加油卡列表" value=">" to="/jiayou_card"/>
            <van-cell title="车卡列表" value=">" to="/cardList"/>
            <van-cell title="司机列表" value=">" to="/driver_list"/>
            <van-cell title="分配记录" value=">" to="/distribution_record"/>
            <van-cell title="加油记录" value=">" to="/ComeOn_record"/>
            <van-cell title="充值流水" value=">" to="/top_up" />
            <van-cell title="修改密码" value=">" to="/upd_password"/>
        </van-cell-group> -->
    </div>
    <div class="choose_fuc">
      <div class="choose_fuc_title">车队管理</div>
      <div class="chooseBox">
        <div class="choose" @click="notAvailable">
          <div class="choose_top">
            <img src="../../static/img/top.png" alt="" />
          </div>
          <div class="choose_text">车队对账</div>
        </div>
        <div class="choose" @click="setShare">
          <div class="choose_top">
            <img src="../../static/img/updPassword.png" alt="" />
          </div>
          <div class="choose_text">车队设置</div>
        </div>
        <div class="choose" @click="updPassWord">
          <div class="choose_top">
            <img src="../../static/img/wode.png" alt="" />
          </div>
          <div class="choose_text">我的 </div>
        </div>
      </div>
      <!-- <van-cell-group>
            <van-cell title="加油卡列表" value=">" to="/jiayou_card"/>
            <van-cell title="车卡列表" value=">" to="/cardList"/>
            <van-cell title="司机列表" value=">" to="/driver_list"/>
            <van-cell title="分配记录" value=">" to="/distribution_record"/>
            <van-cell title="加油记录" value=">" to="/ComeOn_record"/>
            <van-cell title="充值流水" value=">" to="/top_up" />
            <van-cell title="修改密码" value=">" to="/upd_password"/>
        </van-cell-group> -->
    </div>
    <RechargeModal
      :show.sync="showModal"
      :balance="totalBalance"
      @success="handleRecharge"
    />
  </div>
</template>

<script>
import tab from "@/components/NavBar";
import RechargeModal from './RechargeModal.vue'
import Vue from "vue";
import { Cell, CellGroup } from "vant";
import { Dialog } from 'vant';


import { Toast } from "vant";
import Set_share from "./set_share.vue";

Vue.use(Toast);
Vue.use(Cell);
Vue.use(CellGroup);
export default {
  name: "margin",
  data() {
    return {
      totalBalance: "0.00",
      balance: "0.00",
      showModal: false,
      orgCust:{},
      payOver:0
    };
  },
  components: {
    tab,
    RechargeModal
  },
  mounted() {
    this.getBalance();
  },
  methods: {
    GetRequest() {
      //获取?后的参数
      var url = location.search; //获取url中"?"符后的字符串
      // url = '?washCarPlanId=1&openid=odeAi5aFhC_MiPcuk4HhOKwFFiAU&payOver=null' //本地测试
      var strs;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
          // console.log(strs[i].split("="));
          if (strs[i].split("=")[2] == "") {
            theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1] + "=";
          }
        }
      }
      return theRequest;
    },
    handleRecharge(data) {
      console.log("充值结果", data)
      const item = {
        token:this.$storage.get('token'),
        orgCustId:this.orgCust.id,
        openId:this.orgCust.openId,
        merchantId:this.orgCust.merchantId,
        money:data.amount*100,
      }
      const toast1 = Toast.loading({
        message: '支付中...',
        duration: 0, // 持续展示 toast
        forbidClick: true,
      });
      // if(this.payOver == 1) return
      // this.payOver = 1;
      this.$api.post('/app/orgCustChargeOrder', item, res => {
        console.log(res)

        if(res.data && res.data.code == 0){
          if (res.data.data && res.data.data.package) {//没有这个参数 证明不需要调起支付
            Toast('小程序环境，跳转小程序支付');
            var pay_package = res.data.data.package.split('=')[1]
            console.log(pay_package)
            this.showModal = false

            this.wx.miniProgram.navigateTo({ //这将唤起小程序的原生页面
              url: '/pages/washCarPay/washCarPay?timestamp=' + res.data.data.timeStamp + '&nonceStr=' + res.data.data.nonceStr + '&package=' + pay_package + '&paySign=' + res.data.data.paySign
            })
          }
        }else {
          Toast('/app/orgCustChargeOrder 调用失败！');
          setTimeout( () => {
            toast1.clear()
          }, 2000)
        }



      })
    },
    getBalance() {
      var data = {
        token: this.$storage.get("token"),
      };
      this.$api.post("orgapp/getTotalBalance", data, (response) => {
        console.log(response.data);
        if (response.status >= 200 && response.status < 300) {
          console.log(response.data);
          var data = response.data;
          if (data.msg == "success") {
            this.totalBalance = (data.totalBalance / 100).toFixed(2);
            this.balance = (data.balance / 100).toFixed(2);
            this.$storage.set("balance", (data.balance / 100).toFixed(2));
          } else {
            Toast.fail(response.data.msg);
          }
        } else {
          Toast.fail(response.status);
        }
      });
      this.$api.post('orgapp/getOrgCust',{token:this.$storage.get('token')},res=>{
        console.log(res)
        if(res.data.code==0){
          this.orgCust = res.data.orgCust
        }
      })
    },
    toTopup() {
      this.$router.push("top_up");
    },
    distributionRecord() {
      this.$router.push("distribution_record");
    },
    ComeOnRecord() {
      this.$router.push("ComeOn_record");
    },
    jiayouCard() {
      this.$router.push("jiayou_card");
    },
    cardList() {
      this.$router.push("cardList");
    },
    driverList() {
      this.$router.push("driver_list");
    },
    updPassWord(){
      this.$router.push("wode");
        // this.$router.push("upd_password");
    },
    setShare(){
      this.$router.push('setShare')
    },
    notAvailable(){
        // Dialog.alert({
        //   title: '温馨提示',
        //   message: '即刻开通，敬请期待',
        // }).then(() => {

        // });
        // this.$router.push('reconciliation')
        this.$router.push('chooseTIme')


    }
  },
};
</script>

<style scoped>
.main {
  background-color: #f7f8fa;
  height: 100vh;
}
.top_kanban {
  width: 100%;
  height: 34%;
  background-color: #fff;
}

.choose_fuc {
  margin: auto;
  margin-top: 10px;
  border-radius: 10px;
  width: 95%;
  background-color: #fff;
  overflow: hidden;
}
.choose_fuc_title {
  height: 30px;
  line-height: 30px;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #ccc;
  border-bottom: 1px solid #eee;
}
.chooseBox {
  width: 100%;
  height: 60px;
  /* background-color: #01A2E8; */
  display: flex;
  margin: 10px 0;
}
.choose {
  width: 25%;
  height: 100%;
  background-color: #01a2e8;
  margin: 0 5px 0 5px;
  border-radius: 5px;
  margin: auto;
}
.choose_top {
  height: 60%;
  width: 100%;
  text-align: center;
}
.choose_top img {
  width: 30px;
  height: 30px;
  margin-top: 5px;
}
.choose_text {
  text-align: center;
  color: #fff;
  line-height: 24px;
}
.bg_img {
  width: 100%;
  height: 70%;
  background-color: #01a2e8;
}
.bg_img img {
  width: 100%;
  height: 100%;
}
.top_ye {
  width: 49%;
  font-size: 16px;
  text-align: center;
  margin-top: 6px;
}
.balance {
  text-align: center;
  font-size: 24px;
  color: #01a2e8;
}
</style>



// WEBPACK FOOTER //
// src/components/margin.vue